import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Room } from '../models/room';
import { Observable } from 'rxjs';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';

@Injectable({
  providedIn: 'root'
})
export class RoomService {

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  private itemDoc: AngularFirestoreDocument<Room>;
  private item: Observable<Room>;

  constructor(private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }

  select() {
        return this.db.collection<Room>('sbccv_rooms', ref => ref.orderBy('name', 'asc')).snapshotChanges();            
  }

  selectById(id) {
    this.itemDoc = this.db.doc<Room>('sbccv_rooms/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert(entity: Room) {
    delete entity.id;
    return this.db.collection('sbccv_rooms').add(Object.assign({}, entity));
  }

  update(entity: Room) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_rooms').doc(id).set(Object.assign({}, entity));
  }

  delete(entity_id: any) {
    return this.db.collection('sbccv_rooms').doc(entity_id).delete();
  }

  makeMsgError(errorsCode) {
    let msgError: string
    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }

}

